import { createRouter, createWebHistory } from 'vue-router';

// 引入组件
import Login from '@/components/Login.vue';
import manage from '@/components/manage.vue';

// 定义路由
const routes = [
    {
        path: '/', // 路由路径
        name: 'Login', // 路由名称
        component: Login, // 对应的组件
    },
    {
        path: '/manage',
        name: 'manage',
        component: manage,
    },
];

// 创建路由实例
const router = createRouter({
    history: createWebHistory(), // 使用 HTML5 历史模式
    routes, // 路由配置
});

export default router;